import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import Block from '../Block';
import Icon from '../Icon';
import useCustomTable from '../tables/useCustomTable';
import Table from '../tables/Table';
import { useDeleteRestrictionMutation, useLazyGetRestrictionsQuery } from '../../api/restrictionApiSlice';
import NewRestrictionForm from './NewRestrictionForm';

const LimitationBlock = ({currentIndustry}) => {
  const { t } = useTranslation();
  const [getRestrictions, restrinctionResuls] = useLazyGetRestrictionsQuery()
  const {status, data: restrictions=[]} = restrinctionResuls;
  const [deleteRestriciton] = useDeleteRestrictionMutation()

  const industryId = useMemo( () => ( currentIndustry.id ? currentIndustry.id : 0 ), [currentIndustry])
  const onDeleteClick = (id)=>(deleteRestriciton([industryId, id]))

  useEffect(() => {
    const industryId = currentIndustry.id ? currentIndustry.id : 0
    getRestrictions(industryId)
  }, [currentIndustry])

  const columns = [{
      Header: 'Name',
      accessor: 'name',
    },{
      Header: '',
      accessor: 'id',
      Cell: (cell) => <div style={{textAlign: "right"}}>
        <span onClick={() => onDeleteClick(cell.row.original.id)} style={{cursor: "pointer"}}>
          <Icon icon="close-circle" variant="danger" size="lg"/>
        </span>
      </div>
    }
  ]


  const tableOptions = {
    sortable: true,
    filterable: false,
    paginate: true,
    header: false
  }

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tablePageLengthProps
  } = useCustomTable()

  return (
    <Block title={t("industries.blacklistedPublisher")}>
      <Table
          data={restrictions}
          columns={columns}
          {...tableOptions}
          {...tableProps}/>
      <NewRestrictionForm restrictions={restrictions} currentIndustry={currentIndustry}/>
    </Block>
  )
}

export default LimitationBlock;